module.exports = __webpack_public_path__ + "img/vespa_195.04834847.png";